/**
 * @author Max Erekhinskiy <max.erekhinskiy@gmail.com>, Jun 28, 2012 11:51:23 AM
 * @copyright MegaGroup © 2012, megagroup.ru
 */

(function() {
    'use strict';

    var protocol = {
        TYPE_SITE : 0,							// Variable
        TYPE_VISITOR: 1,						// Variable
        TYPE_OPERATOR: 2,						// Variable
        TYPE_ACCOUNT: 3,

        INCOGNITO_ID : '000000000000000000000000',

        CLIENT_CODE_CLOSE_CONNECTION : -1,		// Request
        CLIENT_CODE_VISITOR_REGISTER : 1,		// Request
        CLIENT_CODE_AUTHORIZE : 2,				// Request

        CLIENT_CODE_LIST_CHANNEL : 5,

        CLIENT_CODE_CONNECT_TO_CHANNEL : 7,
        CLIENT_CODE_DISCONNECT_FROM_CHANNEL : 8,

        CLIENT_CODE_GET_DIALOGS : 11,
        CLIENT_CODE_GET_USER_INFO : 12,
        CLIENT_CODE_GET_STAT_DIALOGS : 13,		// Request
        CLIENT_CODE_GET_STAT_USERS : 14,		// Request
        CLIENT_CODE_VISITOR_UPDATE_LAST_PAGE : 15,

        CLIENT_CODE_OPERATOR_READ_MESSAGE: 19,

        SERVER_CODE_OPERATOR_READ_MESSAGE_DONE: 119,
        SERVER_CODE_OPERATOR_READ_MESSAGE_ERROR: -119,

        CLIENT_CODE_SEND_CHAT_MESSAGE : 20,
        CLIENT_CODE_GET_MORE_MESSAGES : 26,				// Request
        CLIENT_CODE_TYPING : 28,

        CLIENT_CODE_SEND_LIVE_FORM : 30,
        CLIENT_CODE_GET_LIVE_FORMS : 32,

        CLIENT_CODE_TRANSFER : 40,
        CLIENT_CODE_BAN : 41,

        CLIENT_CODE_OPERATOR_CHANGE_STATE : 16,				// request to change state (operator)
        SERVER_CODE_OPERATOR_CHANGE_STATE_SUCCESS : 116,	// success
        SERVER_CODE_OPERATOR_CHANGE_STATE_ERROR : -116,		// error
        SERVER_CODE_OPERATOR_STATE_CHANGED : 117,			// event: some operator become active or AFK

        // === Backend autosends
        CLIENT_CODE_SAS_PROCESS_ACTIVATE: 43,
        SERVER_CODE_SAS_PROCESS_ACTIVATE: 143,
        SERVER_CODE_SAS_PROCESS_ACTIVATE_ERROR: -143,

        CLIENT_CODE_SAS_REMOVE: 44,
        SERVER_CODE_SAS_REMOVE: 144,
        SERVER_CODE_SAS_REMOVE_ERROR: -144,

        CLIENT_CODE_SAS_ENABLE: 45,
        SERVER_CODE_SAS_ENABLE: 145,
        SERVER_CODE_SAS_ENABLE_ERROR: -145,

        CLIENT_CODE_SAS_COPY: 46,
        SERVER_CODE_SAS_COPY: 146,
        SERVER_CODE_SAS_COPY_ERROR: -146,

        CLIENT_CODE_SAS_SAVE: 47,
        SERVER_CODE_SAS_SAVE: 147,
        SERVER_CODE_SAS_SAVE_ERROR: -147,

        CLIENT_CODE_SAS_PRELOAD: 48,
        SERVER_CODE_SAS_PRELOAD: 148,
        SERVER_CODE_SAS_PRELOAD_ERROR: -148,

        CLIENT_CODE_SAS_SAVE_ORDER: 49,
        SERVER_CODE_SAS_SAVE_ORDER: 149,
        SERVER_CODE_SAS_SAVE_ORDER_ERROR: -149,
        // !== Backend autosends

        // === Frontend autosends
        CLIENT_CODE_SASF_SYNC: 50,
        SERVER_CODE_SASF_SYNC: 150,
        SERVER_CODE_SASF_SYNC_ERROR: -150,

        CLIENT_CODE_SASF_SEND: 51,
        SERVER_CODE_SASF_SEND: 151,
        SERVER_CODE_SASF_SEND_ERROR: -151,
        // !== Frontend autosends

        // === Autosends broadcast flags
        SERVER_CODE_SASB_UPDATED: 153,
        // !=== Autosends broadcast flags

        CLIENT_CODE_IA_GET_MAP : 61,
        SERVER_CODE_IA_GET_MAP_SUCCESS : 161,
        SERVER_CODE_IA_GET_MAP_ERROR : -161,

        SERVER_CODE_RUN_IA_MAP : 162,
        // SKIP 163

        CLIENT_CODE_LIST_BANS : 64,
        SERVER_CODE_LIST_BANS_SUCCESS : 164,
        SERVER_CODE_LIST_BANS_ERROR : -164,

        CLIENT_CODE_REMOVE_BAN : 65,
        SERVER_CODE_REMOVE_BAN_SUCCESS : 165,
        SERVER_CODE_REMOVE_BAN_ERROR : -165,

        SERVER_CODE_SHOW_WIDGET : 166,

        SERVER_CODE_REGISTRATION_DONE : 101,	// Response
        SERVER_CODE_REGISTRATION_FAIL : -101,	// Response

        SERVER_CODE_AUTHORIZATION_DONE : 102,	// Response
        SERVER_CODE_AUTHORIZATION_FAIL : -102,	// Response

        SERVER_CODE_USER_COME_TO_CHANNEL : 103, // Command
        SERVER_CODE_USER_LEAVE_CHANNEL : 104,	// Command

        SERVER_CODE_CHANNEL_LIST : 105,			// Response

        SERVER_CODE_CHANNEL_CONNECTED : 107,
        SERVER_CODE_CHANNEL_DISCONNECTED : 108,

        SERVER_CODE_USER_WAS_UPDATED : 109,

        SERVER_CODE_NOTIFICATION: 110,

        SERVER_CODE_DIALOGS_HISTORY_DATA : 111,
        SERVER_CODE_USER_DATA : 112,
        SERVER_CODE_STAT_DIALOGS_DATA : 113,
        SERVER_CODE_STAT_VISITORS_DATA : 114,

        SERVER_CODE_MESSAGE_SEND_DONE : 120,
        SERVER_CODE_MESSAGE_SEND_FAIL : -120,

        SERVER_CODE_CHAT_MESSAGE : 125,			// Command
        SERVER_CODE_MORE_MESSAGES : 126,		// Response
        SERVER_CODE_MORE_MESSAGES_ERROR : -126,		// Response
        SERVER_CODE_USER_TYPING : 128,			// Command

        SERVER_CODE_SEND_LIVE_FORM_DONE : 130,		// Response
        SERVER_CODE_SEND_LIVE_FORM_FAIL : -130,		// Response

        SERVER_CODE_NEW_LIVE_FORM_RECIEVED : 131,

        SERVER_CODE_GET_LIVE_FORMS_DONE : 132,		// Response
        SERVER_CODE_GET_LIVE_FORMS_FAIL : -132,		// Response

        SERVER_CODE_ISOLATED_MODE_ENABLED : 133,
        SERVER_CODE_ISOLATED_MODE_DISABLED : 134,

        SERVER_CODE_DOUBLE_AUTH : -162,
        SERVER_CODE_STOP : -152,        // really not used, for backward capability works like -162 (dbl-auth)
        SERVER_CODE_VISITOR_BANNED : -181,
        SERVER_CODE_AUTH_OVERLOADED : -163,

        SERVER_CODE_TRANSFER_DATA : 180,

        SERVER_CODE_NEW_SERVER : -201,

        SUBCODE_BIT_NORMAL : 0,
        SUBCODE_BIT_CRITICAL : 1,
        SUBCODE_BIT_CLEAR_COOKIE : 2,

        END : null,

        hasBit : function(source, bit) {
            return !!(source & bit);
        }
    };

    Onicon.lib('protocol', protocol, true);
})();
